import { firebaseRef } from 'config'

export function tokenize(request) {
  const { token } = firebaseRef.getAuth()
  return new Promise((resolve, reject) => {
    request
      .set('token', token)
      .end((err, res) => {
        if (!!err) {
          if (!!res)
            reject(res.text)
          else reject('Something went wrong, try again or contact us :-)')
        }
        else
          resolve(res.body)
      })
  })
}

export function logException(ex, extra) {
  Raven.captureException(ex, {
    extra
  })
}



/** WEBPACK FOOTER **
 ** ./src/utils/helpers.js
 **/